import { toastr } from 'react-redux-toastr';

import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';
import { getBatchForms } from 'actions/batches';
import { hideEditFormAssociationsModal } from './editFormAssociationsModal';

export const EDIT_FORM_ASSOCIATIONS_REQUEST = 'EDIT_FORM_ASSOCIATIONS_REQUEST';
export const EDIT_FORM_ASSOCIATIONS_SUCCESS = 'EDIT_FORM_ASSOCIATIONS_SUCCESS';
export const EDIT_FORM_ASSOCIATIONS_ERROR = 'EDIT_FORM_ASSOCIATIONS_ERROR';

function requestEditFormAssociations() {
  return {
    type: EDIT_FORM_ASSOCIATIONS_REQUEST,
    isRequestingEditFormAssociations: true,
    editFormAssociationsResponse: null
  };
}

function receiveEditFormAssociations(response) {
  return {
    type: EDIT_FORM_ASSOCIATIONS_SUCCESS,
    isRequestingEditFormAssociations: false,
    editFormAssociationsResponse: response
  };
}

function rejectEditFormAssociationsError(error) {
  return {
    type: EDIT_FORM_ASSOCIATIONS_ERROR,
    isRequestingEditFormAssociations: false,
    editFormAssociationsResponse: null,
    editFormAssociationsError: error
  };
}

export function editBatchFormAssociations(formId, changes, currentPageNumber, currentPageSize, batchId, batchFileId) {
  const postData = Object.assign(changes, {});
  if (postData.legalEntities) {
    if (postData.legalEntities.length === 0) {
      postData.legalEntities = [];
    } else {
      postData.legalEntities = postData.legalEntities.map(le => (Number.isInteger(le) ? le : le.value));
    }
  }
  if (postData.accounts) {
    if (postData.accounts.length === 0) {
      postData.accounts = [];
    } else {
      postData.accounts = postData.accounts.map(a => (Number.isInteger(a) ? a : a.value));
    }
  }

  postData.isNewAccount = postData !== null && postData.newAccount;
  postData.isNewCustomer = postData !== null && postData.newCustomer;

  return (dispatch) => {
    dispatch(requestEditFormAssociations());

    const promise = () => ApiService
      .editFormAssociations(formId, postData)
      .then((response) => {
        dispatch(hideEditFormAssociationsModal());
        dispatch(receiveEditFormAssociations(response.data));
        toastr.success('', 'The form associations has been updated');
        return dispatch(getBatchForms(batchId, batchFileId, currentPageNumber, currentPageSize));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response) {
          dispatch(handleException(error, rejectEditFormAssociationsError, true));
        } else if (error.retries && error.retries > 1) {
          dispatch(handleException(error, rejectEditFormAssociationsError, true));
        }
      });
    return promise();
  };
}
